/* eslint-disable @typescript-eslint/no-explicit-any */
import { requestGetCustomerCarePlan } from 'app/api/customer-care'
import { CustomerCareMessageCode } from 'app/api/customer-care/constant'
import {
  IParamsGetCustomerCarePlan,
  IResponseGetCustomerCarePlan,
} from 'app/api/customer-care/model/customer-care'
import { useBaseTableReportHook } from 'app/components/tables/BaseTableReport/hook'
import {
  IDataBaseTable,
  IParamsHookReport,
} from 'app/components/tables/BaseTableReport/type'
import { isEqual } from 'lodash'
import { Pagination, initialPagination } from 'parkway-web-common'
import { useCommonHook } from '../common-hook'
import { IDataCustomerCarePlanWeekly } from './data'

export const useTableWeeklyHook = (props: IParamsHookReport) => {
  const getDataWeek = async (
    pagination: Pagination,
    params: IParamsGetCustomerCarePlan,
  ) => {
    const initData = {
      pagination: pagination ?? initialPagination,
      data: [],
    } as IDataBaseTable<IDataCustomerCarePlanWeekly>
    try {
      const response: IResponseGetCustomerCarePlan =
        await requestGetCustomerCarePlan({
          periodType: 'week',
          ...props,
          ...params,
          page: pagination?.current ? pagination?.current - 1 : 0,
          pageSize: pagination?.pageSize ?? 10,
        })
      if (
        isEqual(
          response?.msgcode,
          CustomerCareMessageCode.CustomerCarePlan.successGetData,
        )
      ) {
        const dataResponse = response?.data?.rows ?? []
        const data: IDataCustomerCarePlanWeekly[] = dataResponse.map(
          (item, index) => {
            const page = pagination?.current ?? 0
            const pageSize = pagination?.pageSize ?? 10

            const firstNumber = (page - 1) * pageSize + index + 1
            return {
              firstNumber,
              employeeName: item?.employeeName,
              qLeadActual: item?.qLeadActual,
              index: index + 1,
              numCustomerReCare: item?.reCareOldCustomerActual,
            }
          },
        )
        const metadata = response?.data?.metadata
        const totalItem = metadata?.totalItem ?? 0

        return {
          pagination: {
            ...pagination,
            total: totalItem,
          },
          data,
        } as IDataBaseTable<IDataCustomerCarePlanWeekly>
      }
      return initData
    } catch (error) {
      return initData
    }
  }

  const {
    tableData,
    expandedRowKeys,
    handleExpand,
    handleTableChange,
    handleResetExpand,
    fetch,
    fetchLoading,
  } = useBaseTableReportHook({ getTreeTableData: getDataWeek })

  const { columns, onClickImport } = useCommonHook({
    fetch,
    fetchLoading,
    typeHook: 'week',
    currentFilter: props,
  })

  const _onClickImport = async (file: any) => {
    onClickImport(file, 'week')
  }

  const handleTableChangeTable = (pagination: Pagination) => {
    handleTableChange(pagination, props)
  }

  return {
    columns,
    tableData,
    handleTableChange: handleTableChangeTable,
    handleExpand,
    expandedRowKeys,
    handleResetExpand,
    fetch,
    fetchLoading,
    onClickImport: _onClickImport,
  }
}
